import { graphql } from '@generated/gql';

export const FETCH_FORM_TEMPLATE_NAME = graphql(/** GraphQL */ `
  query formTemplateBreadcrumbFetchFormTemplateName(
    $input: FetchFormTemplateInput!
  ) {
    fetchFormTemplate(input: $input) {
      translatedDisplayName {
        ...FormTranslatedString
      }
    }
  }
`);
